import { useQuery } from '@tanstack/react-query';
import { fetchShipmentStatusReason } from '../../data-provider/select-options';

export const useGetShipmentStatusReason = () => {
  return useQuery({
    queryKey: ['shipment-status-reason'],
    queryFn: () => fetchShipmentStatusReason(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
